
import { defineComponent, ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { POST_DANA_BANTUAN, PUT_DANA_BANTUAN } from "@/store/danaBantuan.module";
import AppSelect from '@/components/input/AppSelect.vue';

export default defineComponent({
  components: {
    AppSelect,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    id:{
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}) // Provide a default object to prevent undefined errors
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const modalContent = ref(null);
    const isLoading = ref(false);

    const localData = reactive({
      nama: props.data?.penerima?.nama || props.data?.nama || '',
      nim: props.data?.penerima?.nim || props.data?.nim || '',
      program_studi: props.data?.penerima?.program_studi || props.data?.program_studi || '',
      jenis_bantuan: props.data?.jenis_bantuan || '',
      bulan: props.data?.bulan || '',
      tahun: props.data?.tahun || '',
      jumlah_donasi: props.data?.jumlah_donasi || 0,
    });

    const formattedAmount = computed(() => {
      const amount = Number(localData.jumlah_donasi || 0);
      if (!amount || Number.isNaN(amount)) return '';
      return new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
      }).format(amount);
    });

    const onAmountInput = (event: Event) => {
      const input = event.target as HTMLInputElement;
      const rawValue = input.value.replace(/\D/g, '');
      localData.jumlah_donasi = rawValue ? Number(rawValue) : 0;
      input.value = formattedAmount.value;
    };

    const closeModal = () => {
      isLoading.value = false;
      emit('close');
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {
        const payload = {
          nama: localData.nama,
          nim: localData.nim,
          program_studi: localData.program_studi,
          jenis_bantuan: localData.jenis_bantuan,
          bulan: localData.bulan,
          tahun: localData.tahun,
          jumlah_donasi: localData.jumlah_donasi,
        };

        if(props?.id){
          await store.dispatch(PUT_DANA_BANTUAN, { id: props.id, data: payload });
        }else{
          await store.dispatch(POST_DANA_BANTUAN, { data: payload });
        }
        closeModal();
      } catch (error:any) {
        alert(error?.response?.data?.message || 'Gagal menyimpan data');
        isLoading.value = false;
      }
    };

    return {
      modalContent,
      closeModal,
      handleSubmit,
      isLoading,
      localData,
      formattedAmount,
      onAmountInput
    };
  },
});
